import React from 'react';
import IconFileExport from '../../../../../icons/fileExport';
import IconFilterAlt from '../../../../../icons/filterIconAlt';
import RotateArrow from '../../../../../icons/rotate-arrow';
import { Dropdown } from 'semantic-ui-react';

export const Controls = ({
   onExport,

   stations,
   scheduleFilters,
   setScheduleFilters,

   refetchData,
}) => {
   const getStationColor = (index) => {
      const stationColors = ['#6e7176', '#0d6efd', '#198754', '#dc3545', '#6610f2'];

      return stationColors[index % stationColors.length];
   };

   const changeStationFilter = (station) => {
      if (scheduleFilters.activeStation === station) {
         setScheduleFilters({ ...scheduleFilters, activeStation: 'all' });
      } else {
         setScheduleFilters({ ...scheduleFilters, activeStation: station });
      }
   };

   return (
      <div className="schedule-management__controls">
         <div className="schedule-management__controls-row">
            <input
               type="text"
               className="schedule-management__search-input drivers"
               placeholder="Search schedules..."
               value={scheduleFilters.scheduleSearch}
               onChange={(e) => setScheduleFilters({ ...scheduleFilters, scheduleSearch: e.target.value })}
            />

            <div className="d-flex justify-content-end align-items-center px-0 ml-2" style={{ gap: '12px' }}>
               <Dropdown
                  options={[
                     { key: 'all', text: 'All', value: 'all' },
                     { key: 'unassigned ', text: 'Unassigned ', value: 'Unassigned' },
                  ]}
                  onChange={(_, { value }) => setScheduleFilters({ ...scheduleFilters, assignFilter: value })}
                  value={scheduleFilters.assignFilter}
                  clearable
                  scrolling
                  className="custom-dropdown"
                  compact
                  icon={null}
                  trigger={
                     <div style={{ display: 'flex', alignItems: 'center', height: '1.3rem' }}>
                        <IconFilterAlt className="h-100" />
                     </div>
                  }
               />
               <button className="btn-filter" onClick={refetchData}>
                  <div style={{ height: '1.25rem', display: 'flex' }}>
                     <RotateArrow className="h-100" />
                  </div>
               </button>
            </div>

            <div className="schedule-management__controls-group">
               <button
                  className="schedule-management__controls-nav-button"
                  style={{ backgroundColor: '#DADADA' }}
                  onClick={onExport}
               >
                  <div className="schedule-management__controls-nav-icon dark">
                     <IconFileExport className="h-100" />
                  </div>
                  <span className="schedule-management__controls-nav-span dark-bold">Export</span>
               </button>
            </div>
         </div>
         <div className="schedule-management__controls-row">
            {/* Stations */}
            <div className="schedule-management__station-tabs">
               {stations.map((station, index) => (
                  <button
                     key={station.code}
                     className={`schedule-management__station-tab ${
                        station.code === scheduleFilters.activeStation ? 'active' : ''
                     }`}
                     onClick={() => changeStationFilter(station.code)}
                  >
                     {station.code.toUpperCase()}{' '}
                     <span className="schedule-management__badge" style={{ backgroundColor: getStationColor(index) }}>
                        {station.count}
                     </span>
                  </button>
               ))}
            </div>
         </div>
      </div>
   );
};
